import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Read Only Password Letter ", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "me-3 fw-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "bg-primary text-white w-25px h-25px rounded d-flex justify-content-center align-items-center fw-semibold" }, /*#__PURE__*/_toDisplayString(0), -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card mt-5" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_14 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}

import { ref, reactive, onMounted, inject, Ref, computed } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import InjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
// import MsgPrompt from "@/core/plugins/MsgPrompt";
import TimeShow from "@/components/TimeShow.vue";
import { ElNotification } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadOnlyNotice',
  emits: ["submit"],
  setup(__props, { emit: emits }) {



const languageSelections = ref(LanguageTypes.all);

const getUserInfos = inject<() => object>(
  AccountInjectionKeys.GET_USER_INFOS,
  () => ({})
);
const userInfos = ref<any>({});

const accountDetails = inject<Ref>(
  AccountInjectionKeys.ACCOUNT_DETAILS,
  ref<any>({})
);
const getReadOnlyCode = inject<() => Promise<string>>(
  AccountInjectionKeys.GET_READ_ONLY_CODE,
  () => Promise.resolve("")
);

const openFilePreviewModal = inject(InjectionKeys.OPEN_FILE_MODAL, (media) =>
  // MsgPrompt.error("Not implemented" + media)
  ElNotification({
    title: "Error",
    message: "Not implemented" + media,
    type: "warning",
  })
);

const ruleFormRef = ref<FormInstance>();
const ruleForm = ref<any>({});
const sendToSales = ref(accountDetails.value.salesAccount?.user?.email !== "");
const sendToIb = ref(accountDetails.value.agentAccount?.user?.email !== "");

const kycHistories = ref<any>([]);
const isLoading = ref(false);
const criteria = ref<any>({
  page: 1,
  size: 5,
});

const rules = reactive<FormRules>({
  account: [
    {
      required: true,
      message: "Please input  account",
      trigger: "blur",
    },
  ],

  name: [
    {
      required: true,
      message: "Please input name",
      trigger: "blur",
    },
  ],

  email: [
    {
      required: true,
      message: "Please input email",
      trigger: "blur",
    },
  ],

  language: [
    {
      required: true,
      message: "Please select language",
      trigger: "change",
    },
  ],

  readOnlyPassword: [
    {
      required: true,
      message: "Please input read only password",
      trigger: "blur",
    },
  ],

  date: [
    {
      type: "date",
      required: true,
      message: "Please pick a date",
      trigger: "change",
    },
  ],
});

/**
 * [
 *   sendToSales.value && accountDetails.value.salesAccount.user.email !== ""
 *     ? accountDetails.value.salesAccount.user.email
 *     : undefined,
 *   sendToIb.value && accountDetails.value.agentAccount.user.email !== ""
 *     ? accountDetails.value.agentAccount.user.email
 *     : undefined,
 * ]
 */
const emailList = computed(() => {
  const agentEmail = accountDetails.value.agentAccount.user.email;
  const salesEmail = accountDetails.value.salesAccount.user.email;
  if (
    (!sendToSales.value && !sendToIb.value) ||
    (agentEmail !== "" && salesEmail !== "")
  ) {
    return [];
  }

  if (sendToIb.value && agentEmail !== "") {
    return [agentEmail];
  }

  if (sendToSales.value && salesEmail !== "") {
    return [salesEmail];
  }

  return [agentEmail, salesEmail];
});

const previewMailHtml = async () => {
  const res = await AccountService.getReadOnlyCodeMailReview(
    accountDetails.value.id,
    {
      to: userInfos.value.email,
      bcc: emailList.value,
    }
  );
  openFilePreviewModal({
    content: res,
    title: "Preview",
    contentType: "text/html",
  });
};

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid) => {
    if (!valid) return;

    const bccEmails = ruleForm.value.otherEmails
      .split(",")
      .map((item) => item.trim());

    // if individually or no ib or sales emails
    if (ruleForm.value.sendOutIndividually || !emailList.value.length) {
      [...bccEmails, ...emailList.value].forEach((email) =>
        AccountService.postReadOnlyCodeMail(accountDetails.value.id, {
          to: email,
        })
      );
    } else {
      // sales or ib need to send out, and other emails also need to send out
      // mark other emails as bcc
      [...emailList.value].forEach((email) =>
        AccountService.postReadOnlyCodeMail(accountDetails.value.id, {
          to: email,
          bccs: bccEmails,
        })
      );
    }
    // MsgPrompt.success("Send successfully").then(() => {
    //   emits("submit");
    // });
    ElNotification({
      title: "Success",
      message: "Read Only Notice Send successfully",
      type: "success",
    });
    emits("submit");
  });
};

const resetForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  userInfos.value = await getUserInfos();
  const readOnlyCode = await getReadOnlyCode();
  ruleForm.value = {
    account: accountDetails.value.tradeAccount.accountNumber,
    name: `${userInfos.value.firstName} ${userInfos.value.lastName}`,
    email: userInfos.value.email,
    language: userInfos.value.language,
    bccs: false,
    readOnlyPassword: readOnlyCode,
    date: new Date(),
    otherEmails: "",
    sendOutIndividually: false,
  };
  formEl.resetFields();
};

const getKycSendHistory = async (_page: number) => {
  try {
    isLoading.value = true;
    criteria.value.page = _page;
    const res = await AccountService.queryCommunications({
      rowId: accountDetails.value.id,
      type: 100,
    });
    kycHistories.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  resetForm(ruleFormRef.value);
  getKycSendHistory(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("action.attempted")), 1),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm.value,
          rules: rules,
          "label-width": "150px",
          class: "demo-ruleForm",
          size: "default",
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Account",
              prop: "account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.value.account,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.account) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Name",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "User Email",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.email) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Language",
              prop: "language"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: ruleForm.value.language,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.value.language) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageSelections.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: item.code,
                        label: item.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Send To",
              prop: "bccs"
            }, {
              default: _withCtx(() => [
                (_unref(accountDetails).salesAccount?.uid !== 0)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      modelValue: sendToSales.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sendToSales).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Sales: " + _toDisplayString(_unref(accountDetails).salesAccount?.user?.email), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_unref(accountDetails).agentAccount?.uid !== 0)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 1,
                      modelValue: sendToIb.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sendToIb).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" IB: " + _toDisplayString(_unref(accountDetails).agentAccount?.user?.email), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Read Only",
              prop: "readOnlyPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.value.readOnlyPassword,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.value.readOnlyPassword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Date",
              prop: "date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: ruleForm.value.date,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.value.date) = $event)),
                  type: "date",
                  label: "Pick a date",
                  placeholder: _ctx.$t('action.select'),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Other Emails",
              prop: "otherEmails"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.value.otherEmails,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ruleForm.value.otherEmails) = $event)),
                  placeholder: "use ,  to separate"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "sendOutIndividually"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: ruleForm.value.sendOutIndividually,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ruleForm.value.sendOutIndividually) = $event)),
                  label: "Send out individually"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: previewMailHtml }, {
                  default: _withCtx(() => [
                    _createTextVNode("Preview")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("title.history")), 1),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.operator") + "Id"), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && kycHistories.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycHistories.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.partyId), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: getKycSendHistory,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ])
  ]))
}
}

})